import React, { Component } from "react";
import { injectIntl, intlShape } from "react-intl";

import { Checkbox, DialogBox } from "~/core";
import { messages } from "../../../i18n-messages";

interface IDynamicLayerPreferencesProps {
    intl: intlShape;
    isOpen?: boolean;
    layerName?: string;
    onChangeShowLabels: (evt) => void;
    onClose: () => void;
    showLabels?: boolean;
}
class DynamicLayerPreferences_ extends Component<IDynamicLayerPreferencesProps> {
    render() {
        const { isOpen, layerName, onChangeShowLabels, onClose, showLabels } = this.props;
        const { formatMessage } = this.props.intl;

        return (
            <DialogBox
                closeOnClickOff
                draggable
                isOpen={isOpen}
                onClose={() => onClose()}
                title={`${layerName} - ${formatMessage(messages.layerPreferences)}`}
            >
                <Checkbox
                    label={formatMessage(messages.showLabels)}
                    onChange={(evt) => onChangeShowLabels(evt)}
                    value={showLabels}
                />
            </DialogBox>
        );
    }
}

export const DynamicLayerPreferences = injectIntl(DynamicLayerPreferences_);
